// extracted by css-extract-rspack-plugin
export default {"paidPill":"PY4wBpnVg1QyLd9M","paidPillIconOnly":"wRLrFfxJgs6n0H1w"};